export const BannerIndex = ({
  index,
  total
}: {
  index: number;
  total: number;
}) => {
  return <div className="absolute right-[8px] top-[8px] flex items-center justify-center gap-3xs rounded-[30px] bg-opacity-black-8 px-xs py-4xs text-caption-md-medium text-assistive" data-sentry-component="BannerIndex" data-sentry-source-file="BannerIndex.tsx">
      <span className="text-white">{index}</span>
      <span>/</span>
      <span>{total}</span>
    </div>;
};